import React from "react";
import { HEADER_HEIGHT } from "./layout.js";
import "./Main.css";
import Background from "../assets/Fondos/fondo1.png";
import BackgroundR from "../assets/Fondos/fondoV.png";
class PuestoVenta extends React.Component {
  render() {
    const isMobile = window.innerWidth <= 768;
 const Back = isMobile ? BackgroundR : Background;
    const containerStyle = {
      backgroundImage: `url(${Back})`,
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: `${HEADER_HEIGHT + (isMobile ? 30 : 40)}px`,
      paddingBottom: isMobile ? "130px" : "170px",
      paddingLeft: isMobile ? "18px" : "40px",
      paddingRight: isMobile ? "18px" : "40px",
      boxSizing: "border-box",
      gap: isMobile ? "30px" : "40px",
    };

    const headingStyle = {
      fontFamily: "var(--tera-pixel)", fontWeight: 700,
      color: "#fff",
      fontSize: isMobile ? "1.7em" : "2.4em",
      textTransform: "uppercase",
      textAlign: "center",
    };

    const subtitleStyle = {
      fontFamily: "Halogen-Regular",
      color: "#fff",
      fontSize: isMobile ? "0.9em" : "1.1em",
      textAlign: "center",
      marginTop: "-16px",
    };

    const blockStyle = (color) => ({
      flex: isMobile ? "none" : 1,
      width: isMobile ? "100%" : "auto",
      position: "relative",
      border: `3px solid ${color}`,
      borderRadius: "10px",
      padding: isMobile ? "24px 20px" : "34px 30px",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      alignItems: isMobile ? "center" : "flex-start",
      gap: "10px",
      textAlign: isMobile ? "center" : "left",
    });

    const cornerPixels = (color) => (
      <div
        style={{
          position: "absolute",
          top: "8px",
          right: "8px",
          display: "grid",
          gridTemplateColumns: "repeat(3, 6px)",
          gap: "2px",
        }}
      >
        {Array.from({ length: 9 }).map((_, i) => (
          <div
            key={i}
            style={{
              width: "6px",
              height: "6px",
              backgroundColor: (i + Math.floor(i / 3)) % 2 === 0 ? color : "transparent",
            }}
          />
        ))}
      </div>
    );

    const titleStyle = (color) => ({
      fontFamily: "var(--tera-pixel)", fontWeight: 700,
      color,
      fontSize: isMobile ? "1.8em" : "2.1em",
      textTransform: "uppercase",
      lineHeight: 1,
    });

    const bodyTextStyle = {
      fontFamily: "Halogen-Regular",
      color: "#fff",
      fontSize: isMobile ? "0.88em" : "0.95em",
      lineHeight: 1.4,
      margin: 0,
    };

    const linkStyle = {
      textDecoration: "none",
      display: "flex",
      flexDirection: "column",
      alignItems: isMobile ? "center" : "flex-start",
      gap: "10px",
      width: "100%",
      transition: "transform 0.25s ease",
      cursor: "pointer",
    };

    const handleHover = (e) => {
      e.currentTarget.style.transform = "scale(1.02)";
    };

    const handleOut = (e) => {
      e.currentTarget.style.transform = "scale(1)";
    };

    return (
      <div style={containerStyle}>
        <div>
          <div style={headingStyle}>Venta de entradas</div>
          <div style={subtitleStyle}>¿Vos desde dónde vas a vivirlo?</div>
        </div>

        <div
          style={{
            width: "100%",
            maxWidth: "1000px",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: "20px",
          }}
        >
          <div style={blockStyle("var(--tera-yellow)")}>
            {cornerPixels("var(--tera-yellow)")}
            <a
              href="https://www.edenentradas.ar/event/festival-kilometro-wh"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
              onMouseOver={handleHover}
              onMouseOut={handleOut}
            >
              <div style={titleStyle("var(--tera-yellow)")}>Digital</div>
              <p style={bodyTextStyle}>
                Comprá tu entrada online a través de Eden Entradas.
              </p>
            </a>
          </div>

          <div style={blockStyle("var(--tera-cyan)")}>
            {cornerPixels("var(--tera-cyan)")}
            <a
              href="https://maps.app.goo.gl/cWsSGFoL1MjWwjZGA"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
              onMouseOver={handleHover}
              onMouseOut={handleOut}
            >
              <div style={titleStyle("var(--tera-cyan)")}>Físico</div>
              <p style={{ ...bodyTextStyle, fontFamily: "var(--tera-pixel)", fontWeight: 700 }}>
                Disquerías EDEN
              </p>
              <p style={bodyTextStyle}>Obispo Trejo 15, subsuelo, local 3</p>
              <p style={bodyTextStyle}>Lunes a Viernes de 09:00 a 18:30 hs.</p>
              <p style={bodyTextStyle}>Sábados de 09:00 a 13:00 hs.</p>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default PuestoVenta;
